import { render, staticRenderFns } from "./reviewTicket.vue?vue&type=template&id=94696f18&lang=pug"
import script from "./reviewTicket.vue?vue&type=script&lang=js"
export * from "./reviewTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports